import axios from "axios";
import Cookies from "universal-cookie";
import { backendUrl } from "../utils/url";

const cookies = new Cookies();

const api = axios.create({
  baseURL: backendUrl,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = cookies.get("jwt-auth");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export const adminLogin = async (values) => {
  try {
    const response = await api.post("/auth/login", values);
    return response;
  } catch (error) {
    if (error.response) return error.response;
    if (error.request) throw new Error("خطا در برقراری ارتباط با سرور");
    throw new Error("خطای غیرمنتظره");
  }
};

export const getAdmin = async () => {
  try {
    const response = await api.get("/user/me");
    return response;
  } catch (err) {
    return err.response?.data ?? err.response;
  }
};

export const getAllUsers = async () => {
  try {
    const response = await api.get("/user/all"); // ✅ بدون backendUrl
    return response;
  } catch (err) {
    return err.response;
  }
};

export const getUserById = async (id) => {
  try {
    const response = await api.get("/user/" + id); // ✅ بدون backendUrl
    return response;
  } catch (err) {
    return err.response;
  }
};
